import { Tabs, Tab, Box, TabsProps } from "@mui/material";
import { SyntheticEvent, ReactNode } from "react";
import { PageContainer } from "../PageContainer";

interface TabDefinition {
  label: string;
  content: ReactNode;
  id?: string;
  ariaControlsId?: string;
  disabled?: boolean;
}

interface TabbedPageProps {
  title: string;
  actions?: ReactNode;
  value: number;
  onChange: (event: SyntheticEvent, newValue: number) => void;
  tabs: TabDefinition[];
  tabsProps?: Partial<TabsProps>;
}

const TabPanel = ({
  children,
  value,
  index,
  panelId,
  tabId,
}: {
  children: ReactNode;
  value: number;
  index: number;
  panelId: string;
  tabId: string;
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={panelId}
      aria-labelledby={tabId}
    >
      {value === index && <Box sx={{ pt: 1 }}>{children}</Box>}
    </div>
  );
};

export const TabbedPage = ({
  title,
  actions,
  value,
  onChange,
  tabs,
  tabsProps,
}: TabbedPageProps) => {
  return (
    <PageContainer title={title} actions={actions}>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs value={value} onChange={onChange} aria-label={`${title} tabs`} {...tabsProps}>
          {tabs.map((tab, index) => {
            const tabId = tab.id ?? `tab-${index}`;
            const panelId = tab.ariaControlsId ?? `tabpanel-${index}`;

            return (
              <Tab
                key={tabId}
                label={tab.label}
                id={tabId}
                aria-controls={panelId}
                disabled={tab.disabled}
              />
            );
          })}
        </Tabs>
      </Box>
      {tabs.map((tab, index) => {
        const tabId = tab.id ?? `tab-${index}`;
        const panelId = tab.ariaControlsId ?? `tabpanel-${index}`;

        return (
          <TabPanel
            key={panelId}
            value={value}
            index={index}
            panelId={panelId}
            tabId={tabId}
          >
            {tab.content}
          </TabPanel>
        );
      })}
    </PageContainer>
  );
};

export default TabbedPage;
